




































import {Component, Prop, Vue} from 'vue-property-decorator';
import {Conversation, FormType, Output, UserType} from '@/types/asix';
import ChatbotAvatar from '@/components/images/ChatbotAvatar.vue';
import {AsixModule} from '@/store/modules/asix';
import {AppModule} from '@/store/modules/app';

@Component({
  components: {
    ChatbotAvatar,
  },
})
export default class TextBubble extends Vue {
  private textTypes = [
    FormType.Text,
    FormType.RichText,
    FormType.HeadText,
    FormType.ImgText,
  ]

  @Prop({required: true})
  private conversation!: Conversation;

  get formType() {
    return FormType
  }

  get isChatBot(): boolean {
    return this.conversation.userType === UserType.ChatBot
  }

  get isUser(): boolean {
    return this.conversation.userType === UserType.User
  }

  get texts(): Output[] {
    return this.conversation.outList.filter((o: Output) => this.textTypes.includes(o.expression_form))
  }

  get isLast(): boolean {
    return AsixModule.latestBotConv ? AsixModule.latestBotConv.id === this.conversation.id : false
  }

  public onIntersect(entries: any, observer: any) {
    if (this.isLast) {
      AppModule.setIsShowMoreMsg(!entries[0].isIntersecting)
    }
  }
}
